 <template>
   
    <section class="theme-bg-yellow " id="digital" >
        <div class="container text-center">
            <div class="row text-center" style="align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        margin-top: 20px;
">
                 <div class="row">
              <div class="col-12 text-center" style="margin-bottom:20px;">
               <h2 class="text-green" style="">กยท. ก้าวไกลยุคดิจิทัล</h2>
                <h2 class="text-green" style="">Moving Forward to digital Organization</h2>
               
             
                <img :src='"../assets/images/green-line.png"' alt="/title-line">
              </div>
           </div>
                <div class="col-md-12 text-center">
                   <carousel   v-bind:class='"news-slider"'
                    :margin=30
                    :loop=true
                    :items=1
                    :nav=false
                    :dots=true
                    :dotsEach=true
                    :autoplay=true
                    :responsive="{0:{items:1},768:{items:1},1024:{items:1},1200:{items:1}}"
          >

 


           <div class="item">
        
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div >
             <router-link :to="{ name: 'Blogdetails' }" >
                <img src="../assets/images/digital_5.jpg" alt="news-1" class="img-fluid">
             </router-link>
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12 text-left">
           <p>
           <b>สร้างองค์กรดิจิทัล สู่ New Normal ด้วยเทคโนโลยีดิจิทัลแพลตฟอร์ม</b>  
         </p>
         <p>
           
One Stop Service (OSS) ผ่านระบบโมบายแพลตฟอร์ม ศูนย์รวมการบริการผ่านระบบโมบายแพลตฟอร์ม (Mobile Platform) เพื่อรวบรวม จัดทำ ปรับปรุง และบริหารจัดการระบบต่าง ๆ อย่างมีประสิทธิภาพ สร้างช่องทางการเข้าถึงการให้บริการอย่างครอบคลุมเบ็ดเสร็จสะดวก รวดเร็ว ตอบสนองการใช้บริการ
     </p> </div>
          </div>
           
          </div>


           <div class="item">
        
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div >
             <router-link :to="{ name: 'Blogdetails' }" >
                <img src="../assets/images/digital_4.jpg" alt="news-1" class="img-fluid">
             </router-link>
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12 text-left">
           <p>
           <b> สร้างองค์กรดิจิทัล สู่ New Normal ด้วยเทคโนโลยีดิจิทัลแพลตฟอร์ม</b> 
         </p>
         <p >
      
พัฒนาและปรับปรุงระบบสารสนเทศทางภูมิศาสตร์ (GIS) สร้างระบบ GIS เชิงแพลตฟอร์ม บริหารจัดการพื้นที่ปลูกยางและบริการข้อมูลในระบบแอพพลิเคชั่น ส่งเสริมพัฒนาอุตสาหกรรมยางสู่เกษตรกร โดยจัดหาข้อมูลภาพถ่ายดาวเทียมความละเอียดสูงที่ทันสมัย มาสนับสนุนให้มีความถูกต้อง-แม่นยำ และสนับสนุนการวิเคราะห์ด้านต่าง ๆ เช่น การขนส่ง การกระจายสินค้าเกษตร การทำสวนยางในมิติต่าง ๆ การเชื่อมโยงแปลงยางพาราทั้งประเทศ ฯลฯ
 </p> </div>
          </div>
           
          </div>


         <div class="item">
        
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div >
             <router-link :to="{ name: 'Blogdetails' }" >
                <img src="../assets/images/digital_3.jpg" alt="news-1" class="img-fluid">
             </router-link>
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12 text-left">
           <p>
           <b>  สร้างองค์กรดิจิทัล สู่ New Normal ด้วยเทคโนโลยีดิจิทัลแพลตฟอร์ม</b>
         </p>
         <p >
      
พัฒนาระบบสารสนเทศเพื่อเพิ่มประสิทธิภาพจัดเก็บ CESS (Smart CESS) เพิ่มศักยภาพ พัฒนาระบบจัดเก็บค่าธรรมเนียมส่งยางออกนอกราชอาณาจักร และระบบการเชื่อมโยงข้อมูลกับหน่วยงานที่เกี่ยวข้องอย่างมีประสิทธิภาพ เพื่อให้ผู้ใช้บริการส่งยางออกนอกราชอาณาจักรได้รวดเร็วขึ้น
  </p> </div>
          </div>
           
          </div>
         <div class="item news-slid">
          
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div class="news-box">
             <router-link :to="{ name: 'Blogdetails' }" >
                <img src="../assets/images/digital_2.jpg" alt="news-1" class="img-fluid">
             </router-link>
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12 text-left">
          <p>
           <b> สร้างองค์กรดิจิทัล สู่ New Normal ด้วยเทคโนโลยีดิจิทัลแพลตฟอร์ม </b>  </p>
         <p >
   
	พัฒนาตลาดยางเป็น Digital Platfrom (Thai Rubber Trade) เชื่อมโยงระบบและข้อมูลยางพาราตั้งแต่ผลิตจนถึงส่งมอบสินค้า บริหารตลาดยางมีประสิทธิภาพด้วยข้อมูล Real time เพื่อยกระดับการควบคุมราคายางยุคปัจจุบัน
     </p>  </div>
          </div>
           
          </div>
         <div class="item news-slid">
         
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div class="news-box">
             <router-link :to="{ name: 'Blogdetails' }" >
                <img src="../assets/images/digital_1.jpg" alt="news-1" class="img-fluid">
             </router-link>
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12 text-left">
         <p>
          Rubber Innivation Hub ศูนย์กลางนวัตกรรมและธุรกิจยางพาราภูมิภาคอาเซียน บริหารจัดการยางทั้งระบบ ต้นน้ำ กลางน้ำ ปลายน้ำ ในพื้นที่ระเบียงเศรษฐกิจพิเศษภาคใต้ ที่จังหวัดนครศรีธรรมราช  </p>
        
          </div>
          </div>
           
          </div>

          </carousel>
                    </div>
                </div>
            </div>
      
    </section>
    <!--Package end -->
</template>
<script>
export default {
  name: 'Package'
}
</script> */
